import React, { useEffect, useState } from 'react';

const ConfettiAnimation = ({ isActive, duration = 3000 }) => {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    if (!isActive) {
      setConfetti([]);
      return;
    }

    // Create confetti pieces
    const pieces = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.2,
      duration: 2 + Math.random() * 1,
      color: ['#FF6B6B', '#4ECDC4', '#FFE66D', '#95E1D3', '#A8E6CF', '#FFD3B6', '#FFAAA5', '#FF8B94'][
        Math.floor(Math.random() * 8)
      ],
      size: Math.random() * 8 + 4,
    }));

    setConfetti(pieces);

    // Clear confetti after animation completes
    const timer = setTimeout(() => {
      setConfetti([]);
    }, duration);

    return () => clearTimeout(timer);
  }, [isActive, duration]);

  if (!confetti.length) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      {confetti.map((piece) => (
        <div
          key={piece.id}
          style={{
            position: 'absolute',
            width: `${piece.size}px`,
            height: `${piece.size}px`,
            backgroundColor: piece.color,
            borderRadius: '50%',
            left: `${piece.left}%`,
            top: '-10px',
            animation: `fall ${piece.duration}s linear forwards`,
            animationDelay: `${piece.delay}s`,
          }}
        />
      ))}

      <style>{`
        @keyframes fall {
          to {
            transform: translateY(100vh) rotateZ(360deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ConfettiAnimation;
